export default {
    queryNoticeList: '/gateway/manageBedrock/free/noticecs/queryNoticeList', // 公告列表查询
    // getUser: '/gateway/manageBedrock/logincs/app/permission',
}


// WEBPACK FOOTER //
// ./src/geelyNotice/index/api.js